import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=3922fe09&scoped=true&%3Akey=key"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922fe09",
  null
  
)

export default component.exports